module.exports = __webpack_public_path__ + "static/media/barcelona@3x.ae263aef.jpg";